import { render, staticRenderFns } from "./Post_Modal_Share.vue?vue&type=template&id=f61c6606&scoped=true&"
import script from "./Post_Modal_Share.vue?vue&type=script&lang=js&"
export * from "./Post_Modal_Share.vue?vue&type=script&lang=js&"
import style0 from "./Post_Modal_Share.vue?vue&type=style&index=0&id=f61c6606&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f61c6606",
  null
  
)

export default component.exports